import { NgModule } from "@angular/core";
import { CustomSearchInput } from "./bh-custom-search-input.component";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormErrorModule } from "../form-error/form-error.module";
import { ViewCountFormatModule } from "common/pipe/viewCountFormat/view-count-format.module";

@NgModule({
    imports: [CommonModule, IonicModule, ReactiveFormsModule, FormErrorModule, FormsModule, NgSelectModule, ViewCountFormatModule],
    declarations: [CustomSearchInput],
    exports: [CustomSearchInput]
})
export class CustomSearchInputModule { }